import {
  GET_USER,
  CHANGE_TOWN,
  CLEAR_USER,
  GET_ORDER_ADDRESS,
  EDITING_ADDRESS
} from './mutation-types'

export default {
    getUser: ({commit},user) => {
        commit(GET_USER,user)
      },
      chengeTown: ({commit},townStreet) => {
        commit(CHANGE_TOWN,townStreet)
      },
      clearUser: ({commit}) => {
        commit(CLEAR_USER)
      },
      getOrderAddress: ({commit},orderAddress) => {
        commit(GET_ORDER_ADDRESS,orderAddress)
      },
      editingAddress: ({commit},editingAddress) => {
        commit(EDITING_ADDRESS,editingAddress)
      }
}


// WEBPACK FOOTER //
// ./src/store/actions.js